/**
 * Server-side pagination arithmetic for the URL-state list pages (approvals,
 * audit log). `page` travels through the URL 1-based as text; the hub takes a
 * 0-based `offset`. Dependency-free so the no-jsdom unit tests can import it.
 */

/** `'3'` → `2`; missing, non-numeric or `< 1` → `0`. */
export function pageIndexOf(page: string): number {
  return Math.max(0, (Number(page) || 1) - 1);
}

/** Pages needed for `total` rows — never below 1, so an empty list is "Page 1 of 1". */
export function pageCountOf(total: number, pageSize: number): number {
  return Math.max(1, Math.ceil(total / pageSize));
}
